import { Component, ElementRef, OnInit, TemplateRef, ViewChild, Inject, HostListener, ViewEncapsulation, Renderer2 } from '@angular/core';
import { dedupedPost } from 'src/app/core/utils/api-dedupe.util';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { Location } from '@angular/common';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CONST_AWS_API, API } from 'src/app/core/constants';
import { API as AWS_API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { StorageService } from 'src/app/core/services/storage.service';
import { ConsumerSignInComponent } from '../../landing-pages/consumer/consumer-sign-in/consumer-sign-in.component';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from 'src/app/core/services/app.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import * as moment from 'moment';
import { COLORLIST } from './../../../../core/constants';
import { AddPlaylistComponent } from '../add-playlist/add-playlist.component';
import { MatMenuTrigger } from '@angular/material/menu';
import { UserService } from 'src/app/core/services/user.service';
import { TipsFeedbackPopupComponent } from '../../user/tips-feedback-popup/tips-feedback-popup.component';
import { ReportComponent } from '../../general/report/report.component';
import { contentGroupSlug, rescopeAlbumUrl } from 'src/app/core/utils/album-scope.util';
import { albumVideoPaymentMode, hasVideoDuration } from 'src/app/core/utils/album-video.util';

declare let $: any;
declare let ga: Function;

@Component({
  selector: 'app-album-list',
  templateUrl: './album-list.component.html',
  styleUrls: ['./album-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AlbumListComponent implements OnInit {

  displayedColumns: string[] = ['Play', 'Album', 'Mintues', 'Views', 'Menu'];
  dataSource = new MatTableDataSource();

  displayedColumnsVideo: string[] = ['Thumbnail', 'Play', 'Album', 'Mintues', 'Views', 'Menu'];
  dataSourceVideo = new MatTableDataSource();

  displayedColumnsRecVideo: string[] = ['Thumbnail', 'Play', 'Album', 'Minutes', 'Menu'];
  dataSourceRecVideo = new MatTableDataSource();
  subscriptiondetails: any;

  currentLocation: any;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  getCurrency: any;
  getCurrencytype: any;
  streamInfo: any = {};
  subEvents: any = [];

  settingsData: any = {};
  currentPlayingAudio: HTMLAudioElement;
  ticketsData: any;
  selectedPlan: any = {};
  isShownSideBar = false;
  subscribePayInfoSubscr: Subscription;
  performerInfoSubscr: Subscription;
  initSubscriptions: Subscription;
  selected_music: any = {};

  settingsDataSubscription: Subscription;
  tag_category: string;
  modalRef: BsModalRef;
  performerData: any;
  mediaPlayerDataSubscription: Subscription;
  video_banner_image = ""
  agedata: any;
  myAgeData = [];
  centerAds: any = [];
  rightAds: any = [];
  tickets: any = [];
  channelName: any = "";
  currencyInfoSubscription: Subscription;
  @ViewChild('template', { static: false }) template: TemplateRef<any>;
  videoData: any;
  isVideoPlayed: boolean = false;
  getId: any;
  routerevents: any;
  deviceType: string;
  deviceData: Subscription;
  currentPlayerDataSubscription: Subscription;
  musicPlayerData: any;
  channelId: any;
  channelSubName: any;
  @ViewChild(MatMenuTrigger, { static: false }) mainMenu: MatMenuTrigger;
  currentAudio: any = {};
  currentVideo: any = {};
  currentAudioTime = 0;
  currentVideoTime = 0;
  timezoneVal: any;
  //videoRef = <HTMLInputElement>document.getElementById('uploadedVideoPlayer');
  @ViewChild("uploadedVideoPlayer", { static: false }) uploadedVideoPlayer: ElementRef;

  showAlbumSubscriptionButton: boolean = false;
  showAlbumPaymentButton: boolean = false;

  currentPlayingData: any = null;
  assets_url = environment.assets_url;
  themeColors = environment.themeColors;

  showTipsHover: boolean = false;
  showDonationsHover: boolean = false;

  tipsOrPolls: any;

  //Related to timer
  totalSeconds: number = 0; // Difference between todays date and sales end date
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  displayTime: any;
  showCountDownTimer: boolean = false;
  deviceInfo: string = 'web';
  subChannelName: any;

  constructor(private activatedRoute: ActivatedRoute, public router: Router, private ngxLoader: NgxUiLoaderService,
    private appService: AppService, private location: Location, private commonSubscribeService: CommanSubscribeService,
    private storageService: StorageService, private dialog: MatDialog, private modalService: BsModalService,
    private toastr: ToastrService, public sanitizer: DomSanitizer, private userService: UserService, private titleService: Title, private renderer: Renderer2) {
    this.routerevents = router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        if (this.isPlayVideo) {
          this.modalRef.hide()
          this.router.navigate[(this.router.url)];
        }
      }
    })


    this.appService.currentPlayingAudio.subscribe(
      (audio) => {
        this.currentAudio = audio;
      }
    )
    this.appService.currentPlayingVideo.subscribe(
      (video) => {
        this.currentVideo = video;
      }
    )
    this.appService.currentPlayingAudioTime.subscribe(
      (time) => {
        this.currentAudioTime = time;
      }
    )
    this.appService.currentPlayingVideoTime.subscribe(
      (time) => {
        this.currentVideoTime = time;
      }
    )
    // Open tips/ polls after the video ends
    this.appService.videoEnded.subscribe(
      (value) => {
        if (value == 'videoEnded') {
          this.commonSubscribeService.sendTriggeredEvent({
            actionType: "album",
            clickAction: "VIDEO_COMPLETED",
            metaData: {
              watchedDuration: this.currentVideoTime,
              videoId: this.selectedVideo?.id || null,
              timeStamp: new Date().toISOString()
            },
            organizationId: this.streamInfo?.organization_id || null,
            networkGroupId: this.streamInfo?.network_group_id || null,
          });
          let tipsPopupScreenType;
          if (this.selectedVideo.tip_donation && (this.selectedVideo.tip_donation == 1 || this.selectedVideo.tip_donation == 2)) {
            tipsPopupScreenType = (this.selectedVideo.tip_donation == 1) ? 'Tip' : 'Donation';
            this.openTips(tipsPopupScreenType);
          } else {
            if (this.selectedVideo && this.selectedVideo.polls && this.selectedVideo.polls.length > 0) {
              tipsPopupScreenType = 'Poll';
              this.openPolls(tipsPopupScreenType);
            }
          }
        }
      }
    )
    // Open tips and videos after last video ends
    this.commonSubscribeService.lastAudioEndedSubject.subscribe(
      (result) => {
        console.log(result)
        if (result == 'success') {
          // Open tips
          if (this.streamInfo.tip_donation == 1 ||
            (this.streamInfo.tip_donation != 0 && this.streamInfo.tip_donation != 1 && this.streamInfo.tip_donation != 2
              && this.performer_details['tip_donation'] == 1)
          ) {
            this.openTips('Tip');
          }
          // Open donations
          if (this.streamInfo.tip_donation == 2 ||
            (this.streamInfo.tip_donation != 0 && this.streamInfo.tip_donation != 1 && this.streamInfo.tip_donation != 2
              && this.performer_details['tip_donation'] == 2)
          ) {
            this.openTips('Donation');
          }
          // Open polls
          if (this.streamInfo.tip_donation == 0) {
            this.openPolls('Poll');
          }
        }
      }
    )

  }
  showScroll: boolean;
  showScrollHeight = 200;
  hideScrollHeight = 10;
  isRecommendationsSent: boolean = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if ((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) > this.showScrollHeight) {
      this.showScroll = true;
    }
    else if (this.showScroll && (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) < this.hideScrollHeight) {
      this.showScroll = false;
    }
  }
  ngAfterViewInit() {
    this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
      if (this.settingsData && this.settingsData?.font_primary_color) {
        document.documentElement.style.setProperty('--quaternary1-bg-color', this.settingsData.font_primary_color);
      } else {
        document.documentElement.style.removeProperty('--quaternary1-bg-color');
      }
    })
  }

  ngOnInit() {
    // ngOnInit is re-run after sign-in / tips; drop the previous run's subscriptions so handlers don't stack up.
    // Tracked separately because ngAfterViewInit and playback reuse some of the same field names.
    this.initSubscriptions?.unsubscribe();
    this.initSubscriptions = new Subscription();
    this.deviceInfo = this.commonSubscribeService.getMobileOperatingSystem();
    this.timezoneVal = this.userService.getTimezone();
    this.musicPlayerData = this.commonSubscribeService.musicPlayerData;
    this.commonSubscribeService.sendAlbumStatus("newOpend");
    this.deviceType = this.commonSubscribeService.deviceType;
    this.deviceData = this.commonSubscribeService.getAppType().subscribe(response => {
      this.deviceType = response;
    })
    this.initSubscriptions.add(this.deviceData);
    if (this.deviceInfo != "web" && this.activatedRoute.snapshot.queryParams.user_id) {
      this.getUserInfo(() => {
        this.getPerformerDetails();
      })
    }
    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');

    this.video_banner_image = this.assets_url + "Video1.png";
    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.initSubscriptions.add(this.userInfoSubscription);
    let checkdata = false;
    this.currencyInfoSubscription = this.commonSubscribeService.getCurrencyInfo().subscribe(response => {
      if (response) {
        this.getCurrency = this.storageService.getItem('currency');
        this.getStreamInfo('curr');
        checkdata = true;
      }
    });
    this.initSubscriptions.add(this.currencyInfoSubscription);
    this.tag_category = this.activatedRoute.snapshot.params.tag_category;
    this.settingsData = this.commonSubscribeService.icWebpageSettingsData;

    this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
      this.checkIsSubscribed();
    });
    this.initSubscriptions.add(this.settingsDataSubscription);
    if (!checkdata) {
      this.ngxLoader.start()
      this.getStreamInfo('curr');
      this.ngxLoader.stop()
    }
    if (this.activatedRoute.snapshot.params.channelName) {
      this.channelName = this.activatedRoute.snapshot.params.channelName;
      if (this.channelName[this.channelName.length - 1] == "#") {
        this.channelName = this.channelName.slice(0, -1);
      }
    }


    let perfomerInfoData = this.commonSubscribeService.perfomerInfoData;
    this.performerInfoSubscr = this.commonSubscribeService.getPerfomerInfo().subscribe(response => {
      this.getPerformerInfo(response);
    });
    this.initSubscriptions.add(this.performerInfoSubscr);

    if (Object.keys(perfomerInfoData).length > 0) {
      this.getPerformerInfo(perfomerInfoData);
    }

    this.subscribePayInfoSubscr = this.commonSubscribeService.getSubscribePayInfo().subscribe(response => {
      if (response) {
        this.isShownSideBar = false;
        this.getPerformerDetails('play');
      }
    })
    this.initSubscriptions.add(this.subscribePayInfoSubscr);

    if (Object.keys(this.settingsData).length > 0) {
      document.body.classList.add("home");
    }

    this.mediaPlayerDataSubscription = this.commonSubscribeService.getMediaPlayerData().subscribe(response => {
      if (response.key == "musicList") {
        if (response.value.length > 0) {
          response.value.forEach(e => {
            console.log(e.streamid, "streamid", e.playing, "getmusicdata")
            this.subEvents.forEach(el => {
              console.log(el.streamid, "streamid", el.playing, "getmusicdata")
              if (e.streamid == el.streamid) {
                el.isAudioPlaying = e.playing;
              }

            })
            // if(e.)
          })
        }
        // this.dataSource.data = response.value;
        this.getUserPlaylist();
      }
    });
    this.initSubscriptions.add(this.mediaPlayerDataSubscription);


    // this.currentPlayerDataSubscription = this.commonSubscribeService.getCurrentMusicData().subscribe(response => {
    //   if(response){
    //     this.currentPlayer(response);
    //   }
    // });
    this.getUserPlaylist();
  }

  postRecommandations(orgId){
    if (this.router.url.includes('/preview')) return;
    if (!orgId) {
      console.warn(
        '[Album List][Recommendations] Missing required data:',
        {orgId}
      );
      return;
    }
        try{
            if(orgId){
              let formData = new FormData();``
              formData.append('user_id', this.userInfo.id.toString());
              formData.append('organization_id', orgId.toString() || null);
              formData.append('recommendation_type', 'content');
              formData.append('top_k', '40');
              let url = API.AI_RECOMMENDATION;
              this.appService.postBaseRequest(url, formData).subscribe(result => {
                if (result.statusCode === 200) {
                  // console.log(
                  //   '[Album List][Recommendations] Recommendation success',
                  //   result
                  // );        
                        }
              }, error => {
                console.error(
                  '[Album List][Recommendations] API request failed',
                  {
                    error,
                    userId: this.userInfo.id,
                    organizationId: orgId
                  }
                );
              })
          }
        }catch(error){
          console.error(
            '[Album List][Recommendations] API request failed',
            {
              error,
              userId: this.userInfo.id,
              organizationId: orgId
            }
          );
        }
    }
    

  goTO() {
    const base = this.commonSubscribeService.getChannelBasePath(this.channelName);
    if (this.settingsData.is_preview) {
      this.router.navigate([base + '/subscription-list/preview'], { queryParams: { token: this.activatedRoute.snapshot.queryParams.token } });
    } else {
      if (this.router.url.includes('/channel/')) {
        this.router.navigate([base + '/subscription-list/channel/' + this.settingsData.channelInfo.channel_name]);
        this.commonSubscribeService.getWebPageSettings(this.settingsData.channelInfo.channel_id);
      } else {
        this.router.navigate([base + '/subscription-list']);
        this.commonSubscribeService.getWebPageSettings(0);
      }
    }
  }

  getCurrentTime(e) {
    if (e && e.target && e.target.currentTime) {
      this.appService.currentPlayingVideoTime.next(Math.floor(e.target.currentTime))
    }
  }

  openMenu(i, status) {
    if (status == false) {
      this.subEvents.forEach((element, index) => {
        if (index == i) {
          this.subEvents[index]['openMenu'] = true;
        } else {
          this.subEvents[index]['openMenu'] = false;
        }
      });
    } else {
      this.closeMenu();
    }
  }

  @HostListener('document:click', ['$event'])
  closeMenu() {
    this.subEvents.forEach((element, index) => {
      this.subEvents[index]['openMenu'] = false;
    });
  }

  reportFileData(data, type) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Album ${albumId} report clicked - ${userId}`);
    const u_payload = {
      actionType: "network",
      metaData: {
        title: `Album ${albumId} report clicked`,
        albumId: albumId,
        albumName: this.streamInfo?.stream_video_title || null,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo.organization_id || null,
      clickAction: `album-report`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);
    if (this.userInfo && this.userInfo.access_token) {
      var uploadedVideoPlayer: any = document.getElementById("uploadedVideoPlayer");
      if (type == 'audio') {
        if (this.currentAudio && this.currentAudio.streamid == data.streamid) {
          this.appService.reportData.next({ data: data, type: type, time: this.currentAudioTime })
        }
        else {
          this.appService.reportData.next({ data: data, type: type, time: 0 })
        }
      }
      if (type == 'uploadedVideo' || type == 'recordedVideo' || type == 'playerVideo') {
        if (this.currentVideo && this.currentVideo.streamid == data.streamid) {
          this.appService.reportData.next({ data: data, type: type, time: this.currentVideoTime })
        }
        else {
          this.appService.reportData.next({ data: data, type: type, time: 0 })
        }
      }

      const dialogRef = this.dialog.open(ReportComponent, {
        panelClass: 'app-dialog',
        disableClose: true,
        data: this.settingsData
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result == true) {
          this.subEvents.forEach((element, index) => {
            this.subEvents[index]['openMenu'] = false;
          });
        }

      });
    } else {
      this.requireLogin();
    }
  }

  enablePlay: boolean = false;
  currentPlayer(data, from?) {
    this.subEvents.forEach(element => {
      if (element.streamid == data.streamid && !from) {
        element.isAudioPlaying = true;
      } else {
        element.isAudioPlaying = false;
      }
    });
    this.dataSource.data = this.subEvents;
    let checkAudioPlay = this.subEvents.filter(a => a.isAudioPlaying);
    this.enablePlay = checkAudioPlay.length >= 1 ? true : false;
    //console.log("SUB EVENTS: ", this.subEvents);
  }
  checkAge(callback) {
    let age_limit = parseInt(this.agedata);
    let status = 'confirm';
    if (!isNaN(age_limit)) {
      if (age_limit <= 15) {
        status = 'yes';
      } else if (age_limit <= this.savedageans) {
        status = 'yes'
      } else if (this.userInfo && this.userInfo.date_of_birth) {
        let age = new Date().getFullYear() - new Date(this.userInfo.date_of_birth).getFullYear();
        if (age_limit <= age) {
          status = 'yes';
        }
        else if (age_limit <= this.savedageans) {
          status = 'yes'
        }
        else {
          status = 'confirm'
        }
      }
    }
    else {
      status = 'yes';
    }
    if (status == 'confirm' || status == 'no') {
      let tag_category = this.tag_category == 'recorded-video' ? 'vod' : this.tag_category;
      this.video_audio = this.video_audio ? this.video_audio : this.tag_category;
      let msg = this.subEvents && this.subEvents.length == 1 && this.subEvents[0].stream_status == 'completed' ? 'vod' : 'event';
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'app-signout-confirmation',
        disableClose: true,
        data: { title: "This " + tag_category + " is intended for persons of " + age_limit + " years or older. I agree that my age is " + age_limit + " or above." }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'yes') this.commonSubscribeService.saveDateOfBirth(age_limit, this.streamInfo.organization_id);
        callback(result);
      });
    } else {
      callback(status);
    }
  }
  getAlbumInfo() {
    let data = { "token": this.activatedRoute.snapshot.queryParams.token, "slug": this.activatedRoute.snapshot.params.slug_name };
    this.ngxLoader.start();
    this.appService.postRequest(API.CHANNEL_ALBUM, data).subscribe(response => {
      this.ngxLoader.stop();
      if (response.statusCode === 200) {
        //console.log("GET EVENT BY SLUG: ", response)
        this.getStreamDetails(response, 'preview');
      }
    }, error => {
      this.ngxLoader.stop();
    });
  }

  getPerformerDetails(type?) {
    this.getCurrencytype = this.getCurrency ? this.getCurrency : this.currentLocation && this.currentLocation.currency && this.currentLocation.currency.code;
    let code = this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '';
    let currentCode = code.includes('\"') ? JSON.parse(code) : code;
    let localCurrency = this.getCurrency && this.getCurrency.includes('\"') ? JSON.parse(this.getCurrency) : this.getCurrency
    let channel_name = this.router.url.split("/")[1];
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {
        "channel_name": channel_name,
        "currency": localCurrency ? localCurrency : currentCode,
        "user_id": this.userInfo.id
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_PERFORMER_INFO, data).then(response => {
      this.titleService.setTitle(response.data.Data[0].channel_display_name);
      console.log("pagetitle", response, response.data.Data[0].channel_display_name);
      this.ngxLoader.stop();
      if (response.data.statusCode === '200') {
        this.getPerformerInfo(response, 'stream', 'play');
      }

    });
  }


  getStreamInfo(from?) {
    let slug = this.activatedRoute.snapshot.params.slug_name.includes('?') ? this.activatedRoute.snapshot.params.slug_name.split('?')[0] : this.activatedRoute.snapshot.params.slug_name;
    this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
      // console.log(json);
      if (val == "fail") {
        this.currentLocation = this.currentLocation ? this.currentLocation : {};
      } else {
        this.currentLocation = json;
      }
      this.getCurrencytype = this.getCurrency ? this.getCurrency : this.currentLocation && this.currentLocation.currency && this.currentLocation.currency.code;
      let code = this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '';
      let currentCode = code.includes('\"') ? JSON.parse(code) : code;
      let localCurrency = this.getCurrency && this.getCurrency.includes('\"') ? JSON.parse(this.getCurrency) : this.getCurrency;
      let id = typeof (this.userInfo.id) == 'string' ? this.userInfo.id : JSON.stringify(this.userInfo.id)
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${this.userInfo.access_token}`,
        },
        response: true,
        body: {
          "slug": slug,
          "userid": id || undefined,
          "offset": new Date().getTimezoneOffset(),
          "currency": localCurrency ? localCurrency : currentCode,
          "timezone": this.timezoneVal
        }
      }

      dedupedPost(AWS_API.post.bind(AWS_API), environment.AWS_Cognito.apiName, CONST_AWS_API.GET_EVENT_BY_SLUG, data).then(response => {
        if (response.data.statusCode === '200') {
          this.commonSubscribeService.sendSlugData(response['data']['Data']);
          // Publish date
          let publishLocalTime = moment.utc(response.data.Data.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
          let localPublish = moment.utc(publishLocalTime).local().format("YYYY-MM-DD HH:mm:ss");
          // Today date
          let todayLocalTime = moment.utc(new Date(), "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
          let localToday = moment.utc(todayLocalTime).local().format("YYYY-MM-DD HH:mm:ss");
          this.totalSeconds = moment(localPublish).diff(moment(localToday), 'seconds'); // Getting difference in seconds
          if (this.totalSeconds > 0) {
            this.startTimer();
            this.showCountDownTimer = true;
          } else {
            this.showCountDownTimer = false;
          }
          this.getStreamDetails(response, from);
        } else {
          this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName)]);
        }
      }).catch(error => {

      });
    });

  }
  video_audio = "";
  is_can_see_album = true;
  ticket_ids = [];
  priceDetails: any;
  checkPublishStatus: any;
  albumPlans = [];
  getStreamDetails(response, type?) {
    if (type == 'preview' && response.Data.plans && response.Data.plans.length > 0) {
      this.albumPlans = response.Data.plans;
    }
    if (response.data.Data && response.data.Data.plans && response.data.Data.plans.length > 0) {
      this.albumPlans = response.data.Data.plans;
    }
    //console.log("ALBUM PLANS: ", this.albumPlans)
    try { ga('set', 'page', this.router.url); ga('send', 'pageview'); } catch (e) { }
    if (this.router.url.includes('%')) {
      let url = decodeURIComponent(this.router.url);
      if (url.includes('?id=')) {
        let id = url.split('?')[1];
        this.getId = id.split('=')[1];
      }
    }

    let resp = type == 'preview' ? response.Data : response.data.Data;
    if (type != 'preview') this.alignUrlWithContentScope(resp);
    if (resp.channel_id) {
      this.channelId = resp.channel_id;
      this.channelSubName = resp.channel_id;
      this.subChannelName = resp.channel_name;
      this.commonSubscribeService.getWebPageSettings(resp.channel_id);
    }

    let channelId = 0;
    if (this.plans.length > 0) {
      this.plans.forEach(element => {
        if (element.channel_id == resp.channel_id) {
          channelId = resp.channel_id;
        }
      });
    }

    let SubscriptionPlans = this.subscribedUserPlans;
    this.subscribedUserPlans = [];

    if (SubscriptionPlans.length > 0) {
      SubscriptionPlans.forEach(element => {
        if (element.channel_id == channelId) {
          this.subscribedUserPlans.push(element);
        }
      });
    }

    this.checkPublishStatus = resp.org_past_event;
    resp.stream_info.subData = resp.genre;
    resp.stream_info.subData_Release = resp.metadata ? resp.metadata.release_year : "";
    this.streamInfo = resp.stream_info || {};

    this.ticket_ids = resp['user_subscription_info'] && resp['user_subscription_info'].length > 0 ? resp['user_subscription_info'][0]['ticket_ids'] : [];
    if (this.ticket_ids && this.ticket_ids.length > 0) {
      this.userService.sendUserSub(this.ticket_ids)
    }
    this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
      if (val == "fail") {
        this.currentLocation = this.currentLocation ? this.currentLocation : {};
      } else {
        this.currentLocation = json;
      }
      let allEvents = [];

      this.is_can_see_album = false;
      if (resp.metadata && resp.metadata.additional_info) {
        let additional_info = JSON.parse(resp.metadata.additional_info);
        if (!additional_info.geo_block || additional_info.geo_block.includes("all") || additional_info.geo_block.includes(this.currentLocation.country_code2)) {
          this.is_can_see_album = true;
        }
      } else {
        this.is_can_see_album = true;
      }

      if (resp.subEvents) {
        resp.subEvents.forEach(element => {
          if (!element.metadata) {
            element.metadata = {};
          }
          if (element.metadata.additional_info) {
            let data = JSON.parse(element.metadata.additional_info);
            if (data.geo_block && (data.geo_block.includes("all") || data.geo_block.includes(this.currentLocation.country_code2))) {
              allEvents.push(element);
            } else if (!data.geo_block) {
              allEvents.push(element);
            }
          } else {
            allEvents.push(element);
          }
        });
        resp.subEvents = allEvents;
      }
      resp.subEvents = resp.subEvents ? resp.subEvents.sort((a, b) => a.metadata.track_number < b.metadata.track_number ? -1 : 1) : [];
      this.subEvents = resp.subEvents || [];
      let datesArr = [];
      if (this.subEvents.length > 0) {
        this.subEvents.forEach((event, index) => {
          this.subEvents[index]['shareSubEvent'] = false;
          this.subEvents[index]['isLiked'] = false;
          if (event.conversion_status === "completed") {
            // let eventDate = moment.utc(event.stream_info.publish_date_time).toDate();
            // event.start = moment(eventDate).format('YYYY-MM-DD');
            let eventDate = moment.utc(event.stream_info.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
            event.start = eventDate.format('YYYY-MM-DD');
            datesArr.push(event);
          }
          this.subEvents[index]['openMenu'] = false;
        });
      }
      this.tickets = resp.tickets || [];
      this.priceDetails = resp.price_details;
      this.datesList = [...new Map(datesArr.map(item =>
        [item['start'], item])).values()];

      if (this.datesList && this.datesList.length > 0) {
        this.datesList.forEach(date => {
          date.originalDate = date.start;
          date.start = moment(date.start).format("DD MMM");
          date.day = moment(date.originalDate).format("ddd");
        });
        if (this.tag_category == 'recorded-video') {
          if (this.selectedTabData >= 1) {
            this.selectedTabData = this.selectedDateIndex;
            this.onChangeDate(this.selectedTabEvent);
          } else {
            if (this.datesList && this.datesList.length > 0) {
              let event: any = {
                "index": 0,
                "originalDate": this.datesList[0].originalDate
              }
              this.onChangeDate(event, 0);
            }
          }
        }
      }

      let user_subscription_info = resp.user_subscription_info || [];
      this.subEvents.forEach(ele => {
        ele.stream_info.duration = hasVideoDuration(ele.stream_info.duration) ? this.secondsToTime(ele.stream_info.duration) : null;
        ele.stream_info.stream_payment_mode = albumVideoPaymentMode(ele.stream_info.stream_payment_mode, resp.stream_info?.stream_payment_mode);
        // if (this.subscribedUserPlans && this.subscribedUserPlans.length > 0) {
        //   this.subEvents.forEach(element => {
        //     if (element.plans && this.subscribedUserPlans.length > 0 && element.plans.includes(this.subscribedUserPlans[0].plan_id) && this.userInfo && this.userInfo.access_token)
        //       element.isSubscribed = true;
        //   });
        // }

        if (this.subscribedUserPlans && this.subscribedUserPlans.length > 0 &&
          ele.plans && this.userInfo && this.userInfo.access_token) {

          this.subscribedUserPlans.forEach(element => {
            ele.isSubscribed = false;
            ele.planNotSuff = false;
            if (((element.channel_id == ele.channel_id) || !element.channel_id) && (ele.plans.includes(element.plan_id)) && element.payment == 'success') {
              ele.isSubscribed = true;
              this.checkIsSubscribed();
            } else if (((element.channel_id == ele.channel_id) || !element.channel_id) && (!ele.plans.includes(element.plan_id))) {
              ele.planNotSuff = true;
            }
          });
        }

        if (ele.stream_info.stream_payment_mode == "paid") {
          for (let i = 0; i < user_subscription_info.length; i++) {
            const element = user_subscription_info[i];
            if (element.ticket_ids.includes(ele.stream_info.id)) {
              ele.isPurchased = true;
            }
          }
        }


        // console.log(this.streamInfo.age_limit, this.streamInfo.age_limit <= 15, ele.stream_info.age_limit)
        ele.stream_info.ageInfo = 'Family Friendly';
        if (Number(ele.stream_info.age_limit) <= 15) {
          ele.stream_info.ageInfo = 'Family Friendly';
        } else if (Number(ele.stream_info.age_limit) == 16 || Number(ele.stream_info.age_limit) <= 17) {
          ele.stream_info.ageInfo = 'Adults Supervision';
        } else if (Number(ele.stream_info.age_limit) == 18 || Number(ele.stream_info.age_limit) <= 20) {
          ele.stream_info.ageInfo = '18+';
        } else if (Number(ele.stream_info.age_limit) == 21 || Number(ele.stream_info.age_limit) > 21) {
          ele.stream_info.ageInfo = '21+';
        }
        //console.log(ele.stream_info.ageInfo)
      });
      this.ticketsData = resp.tickets || {};
      let params = this.activatedRoute.snapshot && this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams.device ? false : true;
      if (this.tag_category == "audio") {
        //console.log("SUB EVENTS: ", this.subEvents);
        this.dataSource.data = this.subEvents || [];
        if (this.musicPlayerData) {
          this.currentPlayer(this.musicPlayerData);
        }
        // this.commonSubscribeService.sendMediaPlayerData({ key: "musicList", value: this.subEvents });
        if (params)
          this.commonSubscribeService.sendMediaPlayerData({ key: "is_show_musicPlayer", value: true });
      } else if (this.tag_category == "video") {
        this.dataSourceVideo.data = (this.subEvents || []).sort((a: any, b: any) => (a.showfer_item_order ?? 0) - (b.showfer_item_order ?? 0));
        this.commonSubscribeService.sendMediaPlayerData({ key: "is_show_musicPlayer", value: false });
      }
      this.getId = this.activatedRoute.snapshot.queryParams.id ? this.activatedRoute.snapshot.queryParams.id : this.getId;
      if (this.getId && (type == undefined || type == 'play') && params && !this.activatedRoute.snapshot.queryParams.user_id) {
        // if (!this.isVideoPlayed) {
        //   this.isVideoPlayed = true;
        setTimeout(() => {
          document.getElementById('playVideo' + this.getId).click();
        }, 1000);
        //   }
        // });
      }
      let musicListresponse = this.commonSubscribeService.mediaPlayerData.musicList
      if (musicListresponse) {
        console.log(musicListresponse, "musicListresponse")
        musicListresponse.forEach(e => {
          this.subEvents.forEach(el => {
            console.log(el.streamid, "streamid", el.playing, "musicListresponse")
            if (e.streamid == el.streamid) {
              el.isAudioPlaying = e.playing;
            }

          })
          // if(e.)
        })
      }
    });
    //console.log("STREAM INFO: ", this.streamInfo)

    //To check if the subscription is done or not
    if (this.albumPlans && this.albumPlans.length > 0 && this.plans && this.plans.length > 0) {
      let planExistsFlag = 0;
      this.albumPlans.forEach(albumPlan => {
        this.subscribedUserPlans.forEach(plan => {
          if (albumPlan == plan.plan_id) {
            planExistsFlag = planExistsFlag + 1;
          }
        });
      });
      if (planExistsFlag > 0) {
        this.showAlbumSubscriptionButton = false;
      } else {
        this.showAlbumSubscriptionButton = true;
      }
    }
    //console.log("TICKET IDS: ", this.ticket_ids);

    // To check if the payment is done or not
    this.showAlbumPaymentButton = false
    if (this.streamInfo.stream_payment_mode == 'paid') {
      let planExistsFlag = 0;
      if (this.ticket_ids) {
        if (this.ticket_ids.includes(this.streamInfo.id)) {
          planExistsFlag = planExistsFlag + 1;
        }
        if (planExistsFlag > 0) {
          this.showAlbumPaymentButton = false;
        } else {
          this.showAlbumPaymentButton = true;
        }
      }
      // if album price is paid and all tracks are paid/ subscribed them hide button
      let availableTracksCount = 0;         // Tracks which have non-free pricings and later available to play
      this.subEvents.forEach(subElement => {
        if (subElement.stream_info && subElement.stream_info.stream_payment_mode) {
          if (subElement.stream_info.stream_payment_mode == 'free'
            || subElement.stream_info.stream_payment_mode == 'paid' && subElement.isPurchased
            || subElement.stream_info.stream_payment_mode == 'subscription' && subElement.isSubscribed) {
            availableTracksCount = availableTracksCount + 1;
          }
        }
      });
      if (availableTracksCount == this.subEvents.length) {
        this.showAlbumPaymentButton = false;
      }
      //console.log("AVAILABLE: ",availableTracksCount)
    }
    if (this.streamInfo.tip_donation == 1
      || (this.streamInfo.tip_donation != 0 && this.streamInfo.tip_donation != 1 && this.streamInfo.tip_donation != 2 && this.performer_details['tip_donation'] == 1)
    ) {    //1-> tip, 2-> donation 0 -> none
      this.tipsOrPolls = 'Tip';
    }
    if (this.streamInfo.tip_donation == 2
      || (this.streamInfo.tip_donation != 0 && this.streamInfo.tip_donation != 1 && this.streamInfo.tip_donation != 2 && this.performer_details['tip_donation'] == 2)
    ) {
      this.tipsOrPolls = 'Donation';
    }
    if (this.streamInfo.tip_donation == 0) {
      this.tipsOrPolls = 'none';
    }
    if (this.deviceInfo != 'web') {
      let streamId = this.commonSubscribeService.getParam("id");
      if (streamId == this.streamInfo.id) {
        if (this.streamInfo.stream_payment_mode == 'subscription' && streamId == this.streamInfo.id) {
          this.plans.forEach(plan => {
            if (this.albumPlans && this.albumPlans.includes(plan.id)) {
              this.isShownSideBar = true;
              this.planIds.push(plan.id);
              this.creatorCurrency = this.streamInfo.currency_type;
            }
          });
        } else if ((this.streamInfo.stream_payment_mode == 'paid' && streamId == this.streamInfo.id)) {
          this.paymentStreamInfo = this.streamInfo;
          this.isPaymentShow = true;
        }
      } else {
        this.subEvents.forEach(event => {
          let streamId = this.commonSubscribeService.getParam("id");
          if ((event.stream_info.id == streamId || event.stream_info.parent_streams_id == streamId) && this.deviceInfo != "web") {
            if (event.stream_info.stream_payment_mode == 'subscription' && (!event.isSubscribed || !this.ticket_ids.includes(event.stream_info.parent_streams_id))) {
              this.plans.forEach(plan => {
                if (event.plans && event.plans.includes(plan.id)) {
                  this.isShownSideBar = true;
                  this.planIds.push(plan.id);
                  this.creatorCurrency = event.stream_info.currency_type;
                }
              });
              this.isShownSideBar = true;
            } else if (event.stream_info.stream_payment_mode == 'paid' && (!event.isPurchased || !this.ticket_ids.includes(event.stream_info.parent_streams_id))) {
              this.paymentStreamInfo = event;
              this.isPaymentShow = true;
            }
          }
        })
      }
    }
    //console.log("TICKET DATA: ",this.ticketsData);
  }
  savedageans = 15;
  toggleAudio(data, index, from?) {
    if (data && data.stream_info && data.stream_info.id) {
      this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + "/album/" + data.vod_video_audio + "/" + data.slug], { queryParams: { id: data.stream_info.id } });
    } else if (data && data.id) {
      this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + "/album/" + data.vod_video_audio + "/" + data.slug], { queryParams: { id: data.id } });
    }
    this.agedata = data.stream_info.age_limit
    this.video_audio = data.vod_video_audio;
    if (this.userInfo.access_token) {
      this.commonSubscribeService.sendAlbumStatus("playedsong");
      this.checkAge((status) => {
        if (from == 'pause') {
          data.playing = true;
        }
        this.currentPlayer(data, from);
        if (status == 'yes') {
          this.savedageans = Number(this.agedata) > this.savedageans ? Number(this.agedata) : this.savedageans;
          this.commonSubscribeService.sendMediaPlayerData({ type: "function", key: "toggleAudio", value: { selected_music: data, index: index } });
        } else {
          // this.toastr.info('Age must be above ')
          if (status == 'yes') {
            this.commonSubscribeService.sendMediaPlayerData({ type: "function", key: "toggleAudio", value: { selected_music: data, index: index + 1 } });
          }
        }
      });
      if (!from) {
        this.commonSubscribeService.sendMediaPlayerData({ key: "musicList", value: this.subEvents });
      }

      if (this.rightAds.length > 0) {
        this.rightAdsCount = this.rightAds.length;
        this.rightRollAds(this.rightAds);
      }

    } else {
      this.requireLogin(data);
    }
  }

  requireLogin(data?) {
    let tagCat = this.tag_category ? this.tag_category : data.type;
    let url = '';
    let params = null;
    if (data && data.stream_info && data.stream_info.id) {
      params = Object.keys(this.activatedRoute.snapshot.queryParams).length > 1 ? this.activatedRoute.snapshot.queryParams : { id: data.stream_info.id };
    } else if (data && data.id) {
      params = Object.keys(this.activatedRoute.snapshot.queryParams).length > 1 ? this.activatedRoute.snapshot.queryParams : { id: data.id };
    }
    if (data) {
      let params = null;

      if (data && data.stream_info && data.stream_info.id) {

        params = Object.keys(this.activatedRoute.snapshot.queryParams).length > 1 ? this.activatedRoute.snapshot.queryParams : { id: data.stream_info.id };
        url = this.router.url + '?id=' + data.stream_info.id;
      } else if (data && data.id) {

        params = Object.keys(this.activatedRoute.snapshot.queryParams).length > 1 ? this.activatedRoute.snapshot.queryParams : { id: data.id };

        url = this.router.url + '?id=' + data.id;
      }
      this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + "/album/" + tagCat + "/" + data.slug], { queryParams: params });
    }
    url = url ? url : this.router.url;
    this.storageService.setItem('skipIcRedirection', url);
    const dialogRef = this.dialog.open(ConsumerSignInComponent, {
      maxWidth: "400px",
      panelClass: Object.keys(this.settingsData).length > 0 && this.settingsData.form_bg_color ? "app-consumer-signin" : "app-consumer-sign-in",
      disableClose: true,
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      //console.log(result);
      if (result == "success") {
        this.userInfo = this.commonSubscribeService.userInfo;
        this.getPerformerDetails();
        this.ngOnInit()
      }
      if (!this.router.url.includes('/sign-up'))
        this.storageService.deleteItem('skipIcRedirection');
    });
  }
  // if (!element.stream_info.stream_payment_mode || element.stream_info.stream_payment_mode == 'free' ||
  // element.stream_info.stream_payment_mode == 'free_ads' || (element.plans && this.subscribedUserPlans.length > 0 && element.plans.includes(this.subscribedUserPlans[0].plan_id)
  // || (element.stream_info.stream_payment_mode == 'paid' && element.isPurchased))) {

  playFromBanner(template?) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Album ${albumId} play clicked - ${userId}`)
    const u_payload = {
      actionType: "network",
      metaData: {
        title: `Album ${albumId} play clicked`,
        albumId: albumId,
        albumName: this.streamInfo?.stream_video_title || null,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo.organization_id || null,

      clickAction: `album`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);

    if (this.userInfo.access_token) {
      let isFoundPlayMusic = false, isPlaying = false;
      for (let i = 0; i < this.subEvents.length; i++) {
        const element = this.subEvents[i];
        if (!element.stream_info.stream_payment_mode || element.isPurchased ||
          element.stream_info.stream_payment_mode == 'free' ||
          element.stream_info.stream_payment_mode == 'free_ads' ||
          (element.stream_info.stream_payment_mode == 'subscription' && element.isSubscribed) ||
          (element.plans && (element.stream_info.stream_payment_mode == 'paid' && element.isPurchased))
          || (this.streamInfo.stream_payment_mode == 'paid' && !this.showAlbumPaymentButton)
        ) {
          if (this.subscribedUserPlans.length > 0) {
            this.subscribedUserPlans.forEach(ele => {
              if (((ele.channel_id == element.channel_id) || !ele.channel_id) && (element.plans?.includes(ele.plan_id)) && element.isSubscribed) {
                if (this.tag_category == 'audio') {
                  this.toggleAudio(element, i);
                } else {
                  this.openModalWithClass(template, element,false)
                }
                isPlaying = true;
              } else if (element.isPurchased) {
                if (this.tag_category == 'audio') {
                  this.toggleAudio(element, i);
                } else {
                  this.openModalWithClass(template, element,false)
                }
                isPlaying = true;
              } else if (element.stream_info.stream_payment_mode == 'free' ||
                element.stream_info.stream_payment_mode == 'free_ads') {
                if (this.tag_category == 'audio') {
                  this.toggleAudio(element, i);
                } else {
                  this.openModalWithClass(template, element,false)
                }
                isPlaying = true;
              } else if (this.streamInfo.stream_payment_mode == 'paid' && !this.showAlbumPaymentButton) {
                if (this.tag_category == 'audio') {
                  this.toggleAudio(element, i);
                } else {
                  this.openModalWithClass(template, element,false)
                }
                isPlaying = true;
              }
            });
          } else {
            if (this.tag_category == 'audio') {
              this.toggleAudio(element, i);
            } else {
              this.openModalWithClass(template, element,false)
            }
            isPlaying = true;
          }
          if (isPlaying) {
            isFoundPlayMusic = true;
            break;
          }
        }
      }
      if (!isFoundPlayMusic) {
        if ((this.tag_category == 'video' || this.tag_category == 'audio') && this.subEvents[0].stream_info.stream_payment_mode == 'paid' && !this.subEvents[0].isPurchased) {
          this.openVideoAudioPayment(this.subEvents[0]);
        } else {
          this.doSubscribePayment(this.subEvents[0], false);
        }
        if (this.tag_category == 'recorded-video') {
          let streamInfo = this.subEvents[0].stream_info;
          if (streamInfo.stream_payment_mode == 'paid' && (!this.ticket_ids.includes(streamInfo.id) && !this.ticket_ids.includes(streamInfo.parent_streams_id))) {
            this.redirectTo(this.subEvents[0]);
          } else {
            this.openModalWithClass(template, this.subEvents[0],false);
          }
        }
      }
    } else {
      this.requireLogin(this.subEvents[0]);
    }
  }

  isSubscribed = false;
  checkIsSubscribed() {
    this.isSubscribed = false;
    let cid;
    if (this.settingsData && this.settingsData.channelInfo && this.settingsData.channelInfo.channel_id)
      cid = this.settingsData.channelInfo.channel_id;

    if (this.router.url.includes('/channel/')) {
      if (this.settingsData && this.settingsData.channelInfo && this.settingsData.channelInfo.subscription == 0) {
        cid = 0;
      }
    }
    if (this.subscribedUserPlans) {
      this.subscribedUserPlans.forEach(element => {
        if ((element.channel_id == cid || (!element.channel_id && !this.router.url.includes('/channel/'))) && element.payment == 'success') {
          this.isSubscribed = true;
        }
      });
    }
  }
  goToGener() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Going back from Album ${albumId} - ${userId}`)
    const u_payload = {
      actionType: "network",
      metaData: {
        title: `Going back from Album ${albumId}`,
        albumId: albumId,
        albumName: this.streamInfo?.stream_video_title || null,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo.organization_id || null,

      clickAction: `album`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);
    if (!this.settingsData.is_preview) {
      const base = this.commonSubscribeService.getChannelBasePath(this.channelName);
      if (this.channelId && this.channelId != 0 && this.subChannelName) {
        this.router.navigate([base + "/channel/" + this.subChannelName]);
      } else {
        this.router.navigate([base]);
      }
      //this.router.navigate([base]);
    } else {
      this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + "/preview"]);
    }
    
  }

  org_info: any = {};
  performer_details: any = {};
  plans: any = {};
  subscribedUserPlans: any = [];
  performerId: any;
  organizationId: any;

  getPerformerInfo(response, type?, from?) {
    if (response.data.statusCode === '200') {
      this.performerId = (response && response.data && response.data.Data) && response.data.Data[0] ? response.data.Data[0].performer_id : null;
      this.organizationId = (response && response.data && response.data.Data && response.data.Data[0]) ? response.data.Data[0].organization_id || null : null;
      if (response && response.data && response.data.Data && response.data.Data[0] && response.data.Data[0].org_info) {
        this.org_info = response.data.Data[0].org_info;
        if (this.org_info && this.org_info.vod_site_id && from !== 'subscription_update') {
          this.getAds(type, from);
        }
      }
      if(this.org_info && this.org_info.id && !this.isRecommendationsSent){
        this.isRecommendationsSent = true;
        // this.postRecommandations(this.org_info.id)
      }
      if (response && response.data && response.data.Data && response.data.Data[0] && response.data.Data[0].plans) {
        this.plans = response.data.Data[0].plans;
      }
      if (response && response.data && response.data.Data && response.data.Data[0] && response.data.Data[0].performer_details) {
        this.performer_details = response.data.Data[0].performer_details;
        //console.log(this.performer_details['tip_donation'])
      }
      if (response.data && response.data.Subscription_details && this.userInfo && this.userInfo.access_token) {
        this.subscribedUserPlans = response.data.Subscription_details;
        this.subEvents.forEach(element => {
          element.isSubscribed = false;
          element.planNotSuff = false;

          if (this.subscribedUserPlans.length > 0 && element.plans) {
            this.subscribedUserPlans.forEach(plan => {
              if (((plan.channel_id == element.channel_id) || !plan.channel_id) &&
                (element.plans.includes(plan.plan_id)) && plan.payment == 'success') {
                element.isSubscribed = true;
              } else if (((plan.channel_id == element.channel_id) || !plan.channel_id) &&
                (!element.plans.includes(plan.plan_id))) {
                element.planNotSuff = true;
              }
            });
          }
        });
        // Check if album subscription button should be hidden
        this.checkAlbumSubscriptionStatus();
        // Update subscription status
        this.checkIsSubscribed();
        let val = this.activatedRoute.snapshot && this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams.device ? false : true;
        if (val) {
          this.commonSubscribeService.sendMediaPlayerData({ key: "subscribedUserPlans", value: this.subscribedUserPlans });
          this.commonSubscribeService.sendSubscriberPayedInfo(response.data.Subscription_details);
          this.commonSubscribeService.subscribePayInfoData = response;
        }
      }

      // If this is called after subscription update, don't call getStreamInfo to avoid infinite loop
      if (from === 'subscription_update') {
        return;
      }
    }
  }

  checkAlbumSubscriptionStatus() {
    if (this.albumPlans && this.albumPlans.length > 0 && this.subscribedUserPlans && this.subscribedUserPlans.length > 0) {
      let planExistsFlag = 0;
      this.albumPlans.forEach(albumPlan => {
        this.subscribedUserPlans.forEach(plan => {
          if (albumPlan == plan.plan_id && plan.payment == 'success') {
            planExistsFlag = planExistsFlag + 1;
          }
        });
      });

      if (planExistsFlag > 0) {
        this.showAlbumSubscriptionButton = false;
      } else {
        this.showAlbumSubscriptionButton = true;
      }
    }
  }


  bookingFee;
  totalAmount: any;
  planIds: any = [];
  creatorCurrency: any = '';
  doSubscribePayment(data, doCall, album?,) {

    if (doCall) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
      (window as any).umami?.track(`Album ${albumId} is getting subscribed - ${userId}`)
      const u_payload = {
        actionType: "network",
        metaData: {
          title: `Album ${albumId} is getting subscribed`,
          albumId: albumId,
          albumName: this.streamInfo?.stream_video_title || null,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.streamInfo.organization_id || null,

        clickAction: `album`
      }
      this.commonSubscribeService.sendTriggeredEvent(u_payload);
    }

    if (album && album == 'album') {
      data['stream_info'] = data;
      data['plans'] = this.albumPlans;
    }
    //console.log(data)
    // if (this.subscribedUserPlans.length > 0) {
    //   let plans = this.subscribedUserPlans.filter(plan => plan.payment == 'success');
    //   if (plans.length > 0) {
    //   }
    // }
    let params = null;
    if (data && data.stream_info && data.stream_info.id) {
      params = Object.keys(this.activatedRoute.snapshot.queryParams).length > 1 ? this.activatedRoute.snapshot.queryParams : { id: data.stream_info.id };
    } else if (data && data.id) {
      let params = Object.keys(this.activatedRoute.snapshot.queryParams).length > 1 ? this.activatedRoute.snapshot.queryParams : { id: data.id };

    }
    if (this.deviceType != 'ios') {
      if (this.userInfo.access_token) {
        if (!(data.plans && data.plans.length == 0 && data.stream_info?.stream_payment_mode == 'subscription')) {
          this.openPlansPage();
          return;
        }
        this.bookingFee = 0;
        this.totalAmount = 0;
        let ids = [], names = [];
        if (this.plans.length > 0) {
          this.plans.forEach(plan => {
            if (data.plans && data.plans.includes(plan.id)) {
              this.isShownSideBar = true;
              this.planIds.push(plan.id);
              this.creatorCurrency = data.stream_info.currency_type;
            }
          });
          if (data.plans && data.plans.length == 0 &&
            data['stream_info'] &&
            data['stream_info']['stream_payment_mode'] &&
            data['stream_info']['stream_payment_mode'] == 'subscription') {
            this.toastr.error('Subscription plan not available')
          }
        } else {
          if (data.plans && data.plans.length == 0 &&
            data['stream_info'] &&
            data['stream_info']['stream_payment_mode'] &&
            data['stream_info']['stream_payment_mode'] == 'subscription') {
            this.toastr.error('Subscription plan not available')
          }
        }
        this.selectedPlan.ids = ids;
        this.selectedPlan.names = names;
        this.selectedPlan.bookingFee = (this.performer_details.booking_fee / 100) * this.totalAmount;
        this.selectedPlan.amount_after_dis = this.selectedPlan.bookingFee + this.totalAmount;
      } else {
        this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + "/album/" + data.vod_video_audio + "/" + data.slug], { queryParams: params });
        this.requireLogin(data);
      }
    } else {
      this.redirectToWeb(data, 'subscribe');
    }
  }

  /** Subscription plans page of the album's scope: network or group, and the sub-channel when the album belongs to one. */
  openPlansPage() {
    const base = this.commonSubscribeService.getChannelBasePath(this.channelName);
    if (this.settingsData.is_preview) {
      this.router.navigate([base + '/subscription-list/preview'], { queryParams: { token: this.activatedRoute.snapshot.queryParams.token } });
    } else if (this.channelId && this.channelId != 0 && this.subChannelName) {
      this.router.navigate([base + '/subscription-list/channel/' + this.subChannelName]);
    } else {
      this.router.navigate([base + '/subscription-list']);
      this.commonSubscribeService.getWebPageSettings(0);
    }
  }

  redirectToWeb(resp, type?) {
    let url = environment.CONSUMER_PORTAL + this.commonSubscribeService.getChannelBasePath(this.channelName).replace(/^\//, '') + "/album/" + resp.vod_video_audio + "/" + resp.slug + '?id=' + resp.stream_info.id + "&device=ios";
    let data = {
      type: type ? type : '',
      url: url,
      userInfo: this.userInfo,
      settingsData: this.settingsData
    }
    const dialogRef = this.dialog.open(IOSModalDialog, {
      panelClass: 'ios-modal',
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openSubscribeSideMenu(event?) {
    if (event != "success") {
      this.isShownSideBar = !this.isShownSideBar;
      if (event == "close") {
        this.isShownSideBar = false;
      }
    } else {
      this.isShownSideBar = false;
      this.showAlbumSubscriptionButton = false;
      this.getPerformerDetails('subscription_update')
    }
  }



  noPlan(data) {
    this.toastr.error("Your current subscription plan is not sufficient for this " + data);
  }


  videoURL = "";
  selectedVideo: any = {};
  isPlayVideo: boolean = false;
  selectedStreamInfo: any;
  artistInfo: any;
  async openModalWithClass(template: TemplateRef<any>, ele?,doCall?: boolean) {

    this.artistInfo = ele.metadata;
    let data = ele.stream_info;
    let noAds = false;
    let perfomerInfoData = this.commonSubscribeService.perfomerInfoData;
    let icsettingsData = this.commonSubscribeService.icWebpageSettingsData;
    let benefitPlan: any;
    let networkBenefits: any = {};
    let channelBenefits: any = {};
    let currentChannelId: any;
    let haveChannelPlan = false;
    let subscribedPlan: any;

    if(doCall !== false){
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
      (window as any).umami?.track(`Album ${albumId} play button clicked - ${userId}`)
      const u_payload = {
        actionType: "network",
        metaData: {
          title: `Album ${albumId} play button clicked`,
          albumId: albumId,
          albumName: this.streamInfo?.stream_video_title || null,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.streamInfo.organization_id || null,

        clickAction: `album`
      }
      this.commonSubscribeService.sendTriggeredEvent(u_payload);
    }
    

    if (perfomerInfoData && perfomerInfoData.data) {
      if (perfomerInfoData.data.Subscription_details && perfomerInfoData.data.Subscription_details.length > 0) {
        subscribedPlan = perfomerInfoData.data.Subscription_details;
      }
      currentChannelId = icsettingsData && icsettingsData.channelInfo && icsettingsData.channelInfo.channel_id ? icsettingsData.channelInfo.channel_id : 0;
      if (subscribedPlan && subscribedPlan.length > 0) {
        subscribedPlan.forEach(plan => {
          if (currentChannelId == 0 && plan.channel_id == 0) {
            networkBenefits = plan.benefits;
          } else {
            if (plan.channel_id == currentChannelId && currentChannelId != 0) {
              channelBenefits = plan.benefits;
              console.log("perfomerInfoData", benefitPlan)
            }
          }
        });
      }
      if (perfomerInfoData.data.Data && perfomerInfoData.data.Data[0] && perfomerInfoData.data.Data[0].plans && perfomerInfoData.data.Data[0].plans) {
        let plans = perfomerInfoData.data.Data[0].plans;
        if (plans && plans.length > 0 && currentChannelId != 0) {
          plans.forEach(plan => {
            if (plan.channel_id == currentChannelId) {
              haveChannelPlan = true;
            }
          });
        }
      }
      if ((networkBenefits.ads == 1 && currentChannelId == 0) || (networkBenefits.ads == 1 && !haveChannelPlan) || (channelBenefits.ads == 1)) {
        noAds = true;
      }
    }

    // if(this.tickets.length == 0 && this.tag_category == 'recorded-video'){
    //   this.toastr.info('No tickets found');
    //   return;
    // }
    let tagCat = this.tag_category ? this.tag_category : data.vod_video_audio;
    let tag_category = this.tag_category == 'recorded-video' ? 'vod' : this.tag_category;
    this.agedata = data.age_limit;
    let params = null;
    if (data && data.stream_info && data.stream_info.id) {
      params = Object.keys(this.activatedRoute.snapshot.queryParams).length > 1 ? this.activatedRoute.snapshot.queryParams : { id: data.stream_info.id };
    } else if (data && data.id) {
      params = Object.keys(this.activatedRoute.snapshot.queryParams).length > 1 ? this.activatedRoute.snapshot.queryParams : { id: data.id };
    }

    //this route is for not videos
    if(this.tag_category !== 'video' && this.tag_category !== 'recorded-video'){
      this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + "/album/" + tagCat + "/" + data.slug], { queryParams: params });
    }

    data = data ? data : this.videoData;
    this.selectedStreamInfo = data;
    this.agedata = data.age_limit;
    this.video_audio = tagCat;
    if (this.userInfo.access_token) {
      if (data.stream_payment_mode == 'free') {
        this.checkAge(async (status) => {
          if (status == 'yes') {
            this.savedageans = Number(this.agedata)
            let vod_data = data.vod_urls ? JSON.parse(data.vod_urls) : {};
            this.videoURL = vod_data.master || "";
            if (this.tag_category == 'recorded-video') {
              let isVodUrl = false;
              Object.keys(vod_data).forEach(element => {
                if (vod_data[element].includes('vod.m3u8') && !isVodUrl) {
                  this.videoURL = vod_data[element] || "";
                  isVodUrl = true;
                }
                if (vod_data[element].includes('.m3u8') && !isVodUrl) {
                  this.videoURL = vod_data[element] || "";
                  isVodUrl = true;
                }
              })
            }
            this.selectedVideo = data;
            // this.videoURL = "https://preprod-vod.arevea.tv/54b33145-fc2f-45ac-a556-b8e0f07569e2/hls/377_1622096124728_the_black_eyed_peas_x_j_balvinritmo_bad_boys_for_life1080pclean.m3u8";

            // this.videoURL = {"master":"https://dev1-vod.arevea.com/84419751-fa50-4dd0-8e5b-31b0d0489dcb/hls/2045_1630575844179_videoplayback.m3u8","270p":"https://dev1-vod.arevea.com/84419751-fa50-4dd0-8e5b-31b0d0489dcb/hls/2045_1630575844179_videoplayback_Ott_Hls_Ts_Avc_Aac_16x9_480x270p_15Hz_0.4Mbps_qvbr.m3u8","360p":"https://dev1-vod.arevea.com/84419751-fa50-4dd0-8e5b-31b0d0489dcb/hls/2045_1630575844179_videoplayback_Ott_Hls_Ts_Avc_Aac_16x9_640x360p_30Hz_0.6Mbps_qvbr.m3u8","540p":"https://dev1-vod.arevea.com/84419751-fa50-4dd0-8e5b-31b0d0489dcb/hls/2045_1630575844179_videoplayback_Ott_Hls_Ts_Avc_Aac_16x9_960x540p_30Hz_3.5Mbps_qvbr.m3u8","720p":"https://dev1-vod.arevea.com/84419751-fa50-4dd0-8e5b-31b0d0489dcb/hls/2045_1630575844179_videoplayback_Ott_Hls_Ts_Avc_Aac_16x9_1280x720p_30Hz_3.5Mbps_qvbr.m3u8"}
            await this.startStreamSession();


            if (this.preloadAdsdata.length > 0 && !noAds) {
              // this.adVideo = "";
              // this.showAd = false;
              // this.showTimer = false;
              this.AdsCount = 1;
              // this.AdsCount = this.preloadAdsdata.length;
              this.midRollAds(this.preloadAdsdata);
            } else {
              this.showAd = false;
            }
            this.isPlayVideo = true;

            // for recorded videos and uploaded videos
            if (this.tag_category === 'recorded-video' || this.tag_category === 'video') {
              this.openVideoPlayer({
                videoURL: this.videoURL,
                selectedVideo: this.selectedVideo,
                startSessionResponse: this.startSessionResponse,
                selectedStreamInfo:this.selectedStreamInfo,
                tag_category:this.tag_category,
                channelName:this.channelName,
                showAd:this.showAd,
                subEvents:this.subEvents
              }, data.slug, params);
              return;
            }
            this.modalRef = this.modalService.show(
              template ? template : this.template,
              Object.assign({ keyboard: false }, { class: 'gray modal-lg modal-fullscreen' })
            );
          } else {
            this.toastr.info("This " + tag_category + " is intended for persons of " + parseInt(this.agedata) + " years or older");
            // this.toastr.info('Age must be above ')
            // if (status == 'yes') {
            //   this.commonSubscribeService.sendMediaPlayerData({ type: "function", key: "toggleAudio", value: { selected_music: data, index: index } });
            // }
          }
        });
      } else {
        let vod_data = data.vod_urls ? JSON.parse(data.vod_urls) : {};
        this.videoURL = vod_data.master || "";
        if (this.tag_category == 'recorded-video') {
          Object.keys(vod_data).forEach(element => {
            if (vod_data[element].includes('vod.m3u8')) {
              this.videoURL = vod_data[element] || "";
            }
            if (vod_data[element].includes('.m3u8')) {
              this.videoURL = vod_data[element] || "";
            }
          })
        }
        this.selectedVideo = data;
        // this.videoURL = "https://preprod-vod.arevea.tv/54b33145-fc2f-45ac-a556-b8e0f07569e2/hls/377_1622096124728_the_black_eyed_peas_x_j_balvinritmo_bad_boys_for_life1080pclean.m3u8";

        // this.videoURL = {"master":"https://dev1-vod.arevea.com/84419751-fa50-4dd0-8e5b-31b0d0489dcb/hls/2045_1630575844179_videoplayback.m3u8","270p":"https://dev1-vod.arevea.com/84419751-fa50-4dd0-8e5b-31b0d0489dcb/hls/2045_1630575844179_videoplayback_Ott_Hls_Ts_Avc_Aac_16x9_480x270p_15Hz_0.4Mbps_qvbr.m3u8","360p":"https://dev1-vod.arevea.com/84419751-fa50-4dd0-8e5b-31b0d0489dcb/hls/2045_1630575844179_videoplayback_Ott_Hls_Ts_Avc_Aac_16x9_640x360p_30Hz_0.6Mbps_qvbr.m3u8","540p":"https://dev1-vod.arevea.com/84419751-fa50-4dd0-8e5b-31b0d0489dcb/hls/2045_1630575844179_videoplayback_Ott_Hls_Ts_Avc_Aac_16x9_960x540p_30Hz_3.5Mbps_qvbr.m3u8","720p":"https://dev1-vod.arevea.com/84419751-fa50-4dd0-8e5b-31b0d0489dcb/hls/2045_1630575844179_videoplayback_Ott_Hls_Ts_Avc_Aac_16x9_1280x720p_30Hz_3.5Mbps_qvbr.m3u8"}
        await this.startStreamSession();

        if (this.preloadAdsdata.length > 0 && !noAds) {
          // this.adVideo = "";
          // this.showAd = false;
          // this.showTimer = false;
          this.AdsCount = 1;
          // this.AdsCount = this.preloadAdsdata.length;
          this.midRollAds(this.preloadAdsdata);
        } else {
          this.showAd = false;
        }
        this.isPlayVideo = true;

        // for recorded videos and uploaded videos
        if (this.tag_category === 'recorded-video' || this.tag_category === 'video') {
          this.openVideoPlayer({
            videoURL: this.videoURL,
            selectedVideo: this.selectedVideo,
            startSessionResponse: this.startSessionResponse,
            selectedStreamInfo:this.selectedStreamInfo,
            tag_category:this.tag_category,
            channelName:this.channelName,
            showAd:this.showAd,
            subEvents:this.subEvents
          }, data.slug, params);
          return;
        }

        this.modalRef = this.modalService.show(
          template ? template : this.template,
          Object.assign({ keyboard: false }, { class: 'gray modal-lg modal-fullscreen' })
        );
      }
    } else {
      this.requireLogin();
    }
  }

  /**
   * Keeps the album in its content's scope: network-level content at /<network>/album/…, group content at
   * /<network>/<group>/album/…. Back, the player, payment returns and subscription links are all built from
   * the active scope, so an album opened through the wrong scope is moved (replaceUrl) to the right one.
   */
  alignUrlWithContentScope(resp) {
    const groups = this.commonSubscribeService.perfomerInfoData?.data?.Data?.[0]?.groups || [];
    const target = contentGroupSlug(resp?.network_group_id, groups);
    const current = this.commonSubscribeService.activeGroupSlug || null;
    if (target === undefined || target === current || this.router.url.includes('/preview')) return;
    const url = rescopeAlbumUrl(this.router.url, this.channelName, target);
    if (url) this.router.navigateByUrl(url, { replaceUrl: true });
  }

  /**
   * Opens the album-video player page for uploaded / recorded videos (after all play checks have passed).
   * VideoDetailV2Component overrides this to play inline on the detail page.
   */
  openVideoPlayer(payload: any, slug: string, params: any) {
    this.commonSubscribeService.sendVideoStreamInfo(payload);
    this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + "/album-video/" + slug], { queryParams: params });
  }

  close() {
   
    if (this.router.url.includes("?id")) {
      let url = this.router.url.split("?");
      this.router.navigate([url[0]]);
    }
    this.endSessionWithStreamMetrics();
    this.modalRef.hide();
  }

  startSessionResponse: any = {};
  startStreamSession() {

    let reqData: any = {};
    if (this.tag_category == 'video' || this.tag_category == 'recorded-video') {
      reqData = this.selectedVideo;
    } else {
      reqData = this.selected_music.stream_info;
    }

    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "user_id": this.userInfo.id,
        "event_id": reqData.id,
        "organization_id": reqData.organization_id,
        "performer_id": reqData.performer_id,
        "stream_type": this.tag_category,
        "title": reqData.stage,
        "album": reqData.stream_video_title,
        "artist_id": this.artistInfo.artist_id,
        "network_group_id": reqData.network_group_id || 0
      }
    }
    return AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.START_SESSION, data).then(response => {
      if (response.data.statusCode === '200') {
        this.startSessionResponse = response['data'];
        return this.startSessionResponse;
      }
    }).catch(error => {
      this.ngxLoader.stop();
      throw error;
    });
  }


  endSessionWithStreamMetrics() {
    let url = CONST_AWS_API.END_SESSION;
    let id = this.startSessionResponse ? this.startSessionResponse['Data'] : 0;
    let session_start_time = this.startSessionResponse ? this.startSessionResponse['session_start_time'] : "";
    let reqData: any = {};
    if (this.tag_category == 'video' || this.tag_category == 'recorded-video') {
      reqData = this.selectedVideo;
    } else {
      reqData = this.selected_music.stream_info;
    }
    let data = {
      headers: { 'x-api-key': environment.AWS_Cognito.X_Api_Key },
      response: true,
      body: {
        "id": id,
        "session_start_time": session_start_time,
        "is_final": true,
        "event_id": reqData.id,
        "image_for": 'stream_metrics/' + reqData.stream_video_code + "/" + id,
        "stream_type": this.tag_category,
        "network_group_id": reqData.network_group_id || 0
      }
    }
    AWS_API.post(environment.AWS_Cognito.apiName, url, data).then(response => {
    }, error => {
      console.log("error");
    });
  }

  //Ads
  noloader: boolean = false;
  adVideo: any;
  showAd = false;
  showTimer: any = false;
  AdsCount: number = 1;
  streamAdsData: any;
  sponsorData: any;
  preloadAdsdata = [];

  async getAds(type?, from?) {
    let allDiv = [];
    let count = 0;
    var temp_site_id = null;
    this.preloadAdsdata = [];
    this.centerAds = [];
    this.rightAds = [];
    this.sponsorData = this.streamAdsData;
    var j = 0;
    var i = 1;
    var adTypeIdarr = [];
    var placements = [];
    // this.streamAdsData.forEach(el => {
    // temp_site_id = Number(el.site_id)
    j += 1;
    // adTypeIdarr.push(el.adTypeId);
    placements.push(
      {
        "divName": "div1",
        "networkId": Number(environment.kevel.NETWORK_ID),
        "siteId": this.org_info.vod_site_id,
        "advertiserId": this.org_info.advertiser_id,
        "adTypes": [495],
        // "campaignId": Number(el.campaignId),
        // "flightId": Number(el.flight_id),
        // "adId": Number(el.ad_id)
      },
      {
        "divName": "div2",
        "networkId": Number(environment.kevel.NETWORK_ID),
        "siteId": this.org_info.vod_site_id,
        "advertiserId": this.org_info.advertiser_id,
        "adTypes": [4],
      },
      {
        "divName": "div3",
        "networkId": Number(environment.kevel.NETWORK_ID),
        "siteId": this.org_info.vod_site_id,
        "advertiserId": this.org_info.advertiser_id,
        "adTypes": [5],
      }
    );
    allDiv.push("div1");
    allDiv.push("div2");
    allDiv.push("div3");
    count = count + 1;
    // if (this.streamAdsData.length == count) {
    let data = {
      "placements": placements,
      "allDiv": allDiv
    };
    if (this.org_info.vod_site_id && this.org_info.advertiser_id) {
      //"?NOLOADER"
      this.commonSubscribeService.getAdsData(data, (err, result) => {
        if (result && result.status == 0 && result.Ads_data.length > 0) {
          result.Ads_data.forEach(element => {

            if (element.contents && element.contents[0] && element.contents[0].data.customData && element.contents[0].data.customData.ad_size == "1280x720") {
              this.preloadAdsdata.push(element);
            }
            if (element.contents && element.contents[0] && element.contents[0].data.customData && element.contents[0].data.customData.ad_size == "728x90") {
              this.centerAds.push(element);
            }
            if (element.contents && element.contents[0] && element.contents[0].data.customData && element.contents[0].data.customData.ad_size == "300x250") {
              this.rightAds.push(element);
            }
          });

          if (this.preloadAdsdata.length > 0) {

            if (this.noloader) {
              this.noloader = false;
              this.AdsCount = this.preloadAdsdata.length;
              this.midRollAds(this.preloadAdsdata);
            } else {
              // this.preRollAds();
              this.AdsCount = (this.preloadAdsdata.length > 2) ? 2 : this.preloadAdsdata.length;
              this.midRollAds(this.preloadAdsdata);
            }
          }
          if (this.centerAds.length > 0) {
            this.centerAdsCount = this.centerAds.length;
            this.centerRollAds(this.centerAds);

          }
          // if (this.rightAds.length > 0) {
          //   this.rightAdsCount = this.rightAds.length;
          //   this.rightRollAds(this.rightAds);
          // }

        }
        if (result || !result) {
          if (type == 'stream') {
            this.getStreamInfo(from);
          } else if (!this.settingsData.is_preview) {
            this.getStreamInfo(from);
          } else if (this.activatedRoute.snapshot.queryParams.token && this.router.url.includes('preview')) {
            this.getAlbumInfo();
          } else {
            this.getStreamInfo(from);
          }
        }

      });
    }
    // }
    // });
    // }
  }

  selectedAdData: any;
  async midRollAds(midRollAdsdata) {
    // debugger;
    this.AdsCount = (this.AdsCount - 1);
    this.selectedAdData = midRollAdsdata[this.AdsCount].clickUrl;
    let index = this.AdsCount;
    if (midRollAdsdata[index].contents && midRollAdsdata[index].contents[0] && midRollAdsdata[index].contents[0].body) {
      let adType = midRollAdsdata[index].contents[0];
      let customData = adType.data['customData'] ? adType.data['customData'] : {};
      this.adVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
      this.showAd = true;
      if (customData && customData.minPlayTime && customData.maxPlayTime && (Number(customData.maxPlayTime) <= Number(customData.minPlayTime))) {
        customData.maxPlayTime = Number(customData.minPlayTime) + 1;
      }
      var minplayTime = customData.minPlayTime ? customData.minPlayTime : 10;
      var maxPlayTime = customData.maxPlayTime ? (customData.maxPlayTime * 1000) : 20000;
      this.setTimer(minplayTime, () => { });
      if (midRollAdsdata[index].impressionUrl) {
        this.commonSubscribeService.countAdsImpressions(midRollAdsdata[index].impressionUrl);
      }
      setTimeout(() => {
        this.closeAdd();
      }, maxPlayTime);
    }
    this.loadscript();
  }
  adVideoCenter: any;
  showAdCenter: boolean;
  centerAdsCount: number = 1;
  selectedAdCenterData: any;
  adsCenterCount = 0;
  async centerRollAds(centerAdsdata) {
    // debugger;
    // console.log('centerAdsdata',centerAdsdata);
    this.adsCenterCount = this.adsCenterCount + 1;
    this.centerAdsCount = (this.centerAdsCount - 1);
    this.selectedAdCenterData = centerAdsdata[this.centerAdsCount].clickUrl;
    //  console.log('CenterAdsdatalern more',this.selectedAdCenterData)
    let index = this.centerAdsCount;
    if (centerAdsdata[index].contents && centerAdsdata[index].contents[0] && centerAdsdata[index].contents[0].body) {
      let adType = centerAdsdata[index].contents[0];
      let customData = adType.data['customData'] ? adType.data['customData'] : {};
      // console.log("customData :::::::::::::: ", customData);
      this.adVideoCenter = this.sanitizer.bypassSecurityTrustHtml(adType.body);
      this.showAdCenter = true;
      // console.log("maxPlayTime before ::  ", customData.maxPlayTime);
      if (customData && customData.minPlayTime && customData.maxPlayTime && (Number(customData.maxPlayTime) <= Number(customData.minPlayTime))) {
        customData.maxPlayTime = Number(customData.minPlayTime) + 1;
      }
      var minplayTime1 = customData.minPlayTime ? customData.minPlayTime : 10;
      var maxPlayTime = customData.maxPlayTime ? (customData.maxPlayTime * 1000) : 20000;
      // console.log("maxPlayTime after ::  ", maxPlayTime);
      this.setTimerAd(minplayTime1, () => { });
      if (centerAdsdata[index].impressionUrl) {
        this.commonSubscribeService.countAdsImpressions(centerAdsdata[index].impressionUrl);
      }

    }
    this.loadscript();
  }
  adVideoright: any;
  showAdright: boolean;
  rightAdsCount: number = 1;
  selectedAdRightData: any;
  adsCount = 0;
  async rightRollAds(rightAdsdata) {
    // debugger;
    // console.log('rightAdsdata',rightAdsdata);

    this.adsCount = this.adsCount + 1;
    this.rightAdsCount = (this.rightAdsCount - 1);
    this.selectedAdRightData = rightAdsdata[this.rightAdsCount].clickUrl;
    //  console.log('rightAdsdatalern more',this.selectedAdRightData);
    let index = this.rightAdsCount;
    if (rightAdsdata[index].contents && rightAdsdata[index].contents[0] && rightAdsdata[index].contents[0].body) {
      let adType = rightAdsdata[index].contents[0];
      let customData = adType.data['customData'] ? adType.data['customData'] : {};
      // console.log("customData :::::::::::::: ", customData);
      this.adVideoright = this.sanitizer.bypassSecurityTrustHtml(adType.body);
      // console.log(this.adVideoright,"this.adVideoright")
      // this.adVideoright = this.sanitizer.bypassSecurityTrustHtml(
      //   `<video autoplay muted controls>
      //       <source src="${adType.body}">
      //    </video>`);
      this.showAdright = true;
      // console.log("maxPlayTime before ::  ", customData.maxPlayTime);
      if (customData && customData.minPlayTime && customData.maxPlayTime && (Number(customData.maxPlayTime) <= Number(customData.minPlayTime))) {
        customData.maxPlayTime = Number(customData.minPlayTime) + 1;
      }
      var minplayTime = customData.minPlayTime ? customData.minPlayTime : 10;
      var maxPlayTime = customData.maxPlayTime ? (customData.maxPlayTime * 1000) : 20000;
      // console.log("maxPlayTime after ::  ", maxPlayTime);
      this.setTimerAd(minplayTime, () => { });
      if (rightAdsdata[index].impressionUrl) {
        this.commonSubscribeService.countAdsImpressions(rightAdsdata[index].impressionUrl);
      }
      setTimeout(() => {
        this.rightCloseAdd();
      }, maxPlayTime);
    }
    this.loadscript();
  }
  loadscript() {
    $(document).ready(function () {
      $('.adright img').attr('alt', ' ');
      $('.adright img').attr('title', ' ');
      $('.adcenter img').attr('alt', ' ');
      $('.adcenter img').attr('title', ' ');
      $('.ad img').attr('alt', ' ');
      $('.ad img').attr('title', ' ');
      $('.adcenter').find('video').each(function () {
        this.muted = true;
      });
      $('.adright').find('video').each(function () {
        this.muted = true;
      });


    });
  }
  showSkip: boolean = false;
  secondsData: any;
  centerCloseAdd() {
    // console.log("showSkip", this.showSkip);
    if (this.showSkip) {
      if (this.centerAdsCount > 0 && this.centerAds.length > 0) {
        this.centerRollAds(this.centerAds);
      } else {
        this.centerAdsCount = 0;
        this.adsCenterCount = 0;
        this.centerAds = [];
        this.closeButton = true;
        this.showAdCenter = false;
        this.showSkip = false;
        this.showTimer = false;
        //console.log("::::::::::::::::::: All ads gets skiped center");
        // if (this.rightAds.length > 0) {
        //   this.rightAdsCount = this.rightAds.length;
        //   this.rightRollAds(this.rightAds);
        // }
        // if (!this.isStartedPhenixStream) {
        //   this.startSubscribeStream();
        // }
      }
    }
  }

  rightCloseAdd() {
    // console.log("showSkip", this.showSkip);
    if (this.showSkip) {
      if (this.rightAdsCount > 0 && this.rightAds.length > 0) {
        this.rightRollAds(this.rightAds);
      } else {
        this.rightAdsCount = 0;
        this.adsCount = 0;
        this.rightAds = [];
        this.closeButton = true;
        this.showAdright = false;
        this.showSkip = false;
        this.showTimer = false;
        //console.log("::::::::::::::::::: All ads gets skiped right");
        // if (!this.isStartedPhenixStream) {
        //   this.startSubscribeStream();
        // }
      }
    }
  }
  setTimer(playTime, callback) {
    callback();
    let j = 0;
    this.showSkip = false;
    var interval = setInterval(() => {
      if (j >= playTime) {
        this.secondsData = "Skip Ads";
        this.showSkip = true;
      } else {
        this.secondsData = "Skip Ads in " + (playTime - j);
      }
      this.showTimer = true;
      if (j >= playTime) {
        clearInterval(interval);
      }
      j += 1;
    }, 1000);
  }
  closeButton: boolean = false;
  closeAdd() {
    if (this.showSkip) {
      if (this.AdsCount > 0 && this.preloadAdsdata.length > 0) {
        this.midRollAds(this.preloadAdsdata);
      } else {
        this.AdsCount = 0;
        // this.preloadAdsdata = [];
        this.closeButton = true;
        this.showAd = false;
        this.showSkip = false;
        this.showTimer = false;

        // if (!this.isStartedPhenixStream) {
        //   this.startSubscribeStream();
        // }
      }
    }
  }

  secondsToTime(e) {
    var h = Math.floor(e / 3600).toString().padStart(2, '0'),
      m = Math.floor(e % 3600 / 60).toString().padStart(2, '0'),
      s = Math.floor(e % 60).toString().padStart(2, '0');
    if (h == "00")
      return m + ':' + s;
    else
      return h + ':' + m + ':' + s;
  }

  setTimerAd(playTime, callback) {
    callback();
    let j = 0;
    this.showSkip = false;
    var interval = setInterval(() => {
      if (j >= playTime) {
        this.secondsData = "Skip Ads";
        this.showSkip = true;
      } else {
        this.secondsData = "Skip Ads in " + (playTime - j);
      }
      this.showTimer = true;
      // console.log("::::::::::::::::::: ", this.secondsData, typeof this.secondsData );
      if (j >= playTime) {
        clearInterval(interval);
      }
      j += 1;
    }, 1000);
  }

  //playlist
  createPlayList(type) {
    if (this.userInfo.access_token) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
      (window as any).umami?.track(`Creating new playlist for album ${albumId}`);
      const u_payload = {
        actionType: "network",
        metaData: {
          title: `Creating new playlist for album ${albumId}`,
          albumId: albumId,
          albumName: this.streamInfo?.stream_video_title || null,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.streamInfo.organization_id || null,

        clickAction: 'playlist'
      }
      this.commonSubscribeService.sendTriggeredEvent(u_payload);

      let data = {
        performerId: this.performerId,
        playlist_type: type,
        settingsData: this.settingsData,
        organization_id: this.organizationId || null
      }
      const dialogRef = this.dialog.open(AddPlaylistComponent, {
        data: { details: data },
        width: '50%',
        height: '268px',
        panelClass: "app-add-playlist",
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result == "yes") {
          this.getUserPlaylist();
        }
      });
    } else {
      this.requireLogin();
    }
  }

  addToPlayList(streamData, playList) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Album ${albumId} added to playlist - ${userId}`)
    const u_payload = {
      actionType: "network",
      metaData: {
        title: `Album ${albumId} adding to playlist`,
        albumId: albumId,
        albumName: this.streamInfo?.stream_video_title || null,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo.organization_id || null,

      clickAction: `album`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "id": playList.id,
        "user_id": this.userInfo.id,
        "stream_id": streamData.streamid,
        "parent_streams_id": streamData.parent_streams_id,
        "thumbnail": streamData.stream_info.video_thumbnail_image,
        "organization_id": this.organizationId || null
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.SAVE_USER_PLAYLIST, data).then(response => {
      this.ngxLoader.stop();
      if (response.data.statusCode === '200') {
        this.toastr.success('Added to playlist successfully');
      } else {
        this.toastr.error(response.data.message)
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });

  }


  playListAry = [];
  getUserPlaylist() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "user_id": Number(this.userInfo.id),
        "organization_id": this.organizationId || null
      }
    }
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER_PLAYLIST, data).then(response => {
      if (response.data.statusCode === '200') {
        if (response['data']['Data'] && response['data']['Data'].length > 0) {
          this.playListAry = [];
          if (this.router.url.includes('audio'))
            this.playListAry = response.data['Data'].filter(res => res.playlist_type === 'audio' && res.performer_id == this.performerId);
          else
            this.playListAry = response.data['Data'].filter(res => res.playlist_type === 'video' && res.performer_id == this.performerId);
        }
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });

  }

  deleteUserPlayList(id) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "id": id
      }
    }
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.DELETE_USER_PLAYLIST, data).then(response => {
      if (response.data.statusCode === '200') {
        console.log(response['data']);
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }
  //Single Payment
  isPaymentShow = false;
  paymentStreamInfo: any = {};
  showTicketsList: boolean = false;
  selectedStageTickets: any = [];

  openVideoAudioPayment(data, album?) {
    if (!this.isPaymentShow) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
      (window as any).umami?.track(`Album ${albumId} video/audio payment clicked - ${userId}`)
      const u_payload = {
        actionType: "network",
        metaData: {
          title: `Album ${albumId} video/audio payment clicked`,
          albumId: albumId,
          albumName: this.streamInfo?.stream_video_title || null,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.streamInfo.organization_id || null,

        clickAction: `album`
      }
      this.commonSubscribeService.sendTriggeredEvent(u_payload);
      if (album && album == 'album') {
        let tempStreamInfo = {};
        for (var k in data) {
          tempStreamInfo[k] = data[k]
        }
        tempStreamInfo['stream_info'] = this.streamInfo;
        data = tempStreamInfo;
      }
      if (!album) {
        let trackIndex = this.subEvents.findIndex(p => p.streamid == data.streamid);
        this.mediaPlayerDataSubscription = this.commonSubscribeService.getMediaPlayerData().subscribe(
          (response) => {
            this.saveCurrentPlayingData(response);
          },
        )
        //console.log("CURRENT PLAY DATA: ",this.currentPlayingData);
        if ((this.currentPlayingData && this.currentPlayingData['key'] == "musicList")) {
          this.toggleAudio(data, trackIndex, 'pause'); // keep condition if only when there is player data then pause
        }
      }
      let tagCat = this.tag_category ? this.tag_category : data.vod_video_audio;
      let tag_category = this.tag_category == 'recorded-video' ? 'vod' : this.tag_category;
      this.agedata = data.stream_info.age_limit;
      let params = null;
      if (data && data.stream_info && data.stream_info.id) {
        params = Object.keys(this.activatedRoute.snapshot.queryParams).length > 1 ? this.activatedRoute.snapshot.queryParams : { id: data.stream_info.id };
      } else if (data && data.id) {
        params = Object.keys(this.activatedRoute.snapshot.queryParams).length > 1 ? this.activatedRoute.snapshot.queryParams : { id: data.id };
      }
      this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + "/album/" + tagCat + "/" + data.slug], { queryParams: params });
      if (album && album == 'album') {
        this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + "/album/" + data.vod_video_audio + "/" + data.slug]);
        this.commonSubscribeService.sendMediaPlayerData({ key: "musicList", value: this.subEvents });
        this.commonSubscribeService.sendMediaPlayerData({ key: "is_show_musicPlayer", value: true });
      }
      if (this.deviceType != 'ios') {
        if (this.userInfo.access_token) {
          this.checkAge((status) => {
            if (status == 'yes') {
              this.selectedStageTickets = this.tickets.filter(a => (a.ticket_type == 'paid' && (a.sessions.includes(this.streamInfo.id) || a.sessions.includes(this.streamInfo.parent_streams_id))))
              if (this.selectedStageTickets.length > 1 && this.tag_category == 'recorded-video') {
                this.showTicketsList = true;
                this.paymentStreamInfo = data;
                return;
              }
              this.paymentStreamInfo = data;
              this.isPaymentShow = true;
            } else {
              this.toastr.info("This " + tag_category + " is intended for persons of " + parseInt(this.agedata) + " years or older");
            }
          });
        } else {
          this.requireLogin(data);
        }
      } else {
        this.redirectToWeb(data);
      }
    } else {  // If already the payment nav is opened
      let errorMessage = album ? 'with this album' : 'with this track'
      this.toastr.error("Complete or close the ongoing payment to proceed " + errorMessage)
    }
  }

  saveCurrentPlayingData(data) {
    //console.log(data)
    this.currentPlayingData = data;
  }

  closeTicketsMenu() {
    this.showTicketsList = false;
  }

  selectTicket(ticket) {
    this.showTicketsList = false;
    this.paymentStreamInfo.selectedTicket = ticket;
    if (this.userInfo.access_token) {
      this.isPaymentShow = true;
    } else {
      this.requireLogin(this.paymentStreamInfo);
    }
  }

  togglePaymentSideMenu(event?) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Album ${albumId} payment cancelled - ${userId}`)
    const u_payload = {
      actionType: "network",
      metaData: {
        title: `Album ${albumId} payment cancelled`,
        albumId: albumId,
        albumName: this.streamInfo?.stream_video_title || null,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo.organization_id || null,

      clickAction: `album`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);

    if (event != "success") {
      this.isPaymentShow = !this.isPaymentShow;
      if (event == "close") {
        this.isPaymentShow = false;
      }
    } else {
      this.isPaymentShow = false;
      //this.ngOnInit();
      this.getStreamInfo();
    }
  }

  //Recorded videos
  sortedEventsData = [];
  userColor: any = {};
  countUserColor = 0;
  guestList: any;
  selectedTab: any;
  selectedDate: any;
  selectedTabEvent: any;
  selectedDateIndex: any;
  selectedTabData: number;
  datesList: any = [];
  selected_Date = 0;
  onChangeDate(event, index?) {
    if (event) {
      this.selectedTabEvent = event;
      this.selectedDateIndex = index;
      this.selectedDate = moment(event.originalDate).format("YYYY-MM-DD");
      let val = this.checkPublishStatus ? this.checkPublishStatus.split('_')[1] == 1 ? true : false : false;
      if (this.subEvents && this.subEvents.length > 0 && ((this.checkPublishStatus && val) || this.router.url.includes('/preview'))) {
        this.sortedEventsData = [];
        this.subEvents.forEach(event => {
          event.finalGuestsList = [];
          // let eventDate = moment.utc(event.stream_info.publish_date_time).toDate();
          // let s = moment(eventDate).format('YYYY-MM-DD');
          let eventDate = moment.utc(event.stream_info.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
          let s = eventDate.format('YYYY-MM-DD');
          if (s == this.selectedDate) {
            event.isMatched = true;
            if (event.conversion_status === "completed") {
              this.sortedEventsData.push(event);
            }
            if (this.tag_category == 'recorded-video' && !this.router.url.includes('/preview')) {
              this.tickets = this.tickets.filter(a => a.is_vod);
            }
            if (this.tickets.length > 0 && !this.router.url.includes('/preview')) {
              this.sortedEventsData.forEach(event => {
                this.tickets.forEach(element => {
                  if (element.ticket_type == 'paid' && (element.sessions.includes(event.streamid) || element.sessions.includes(event.parent_streams_id))) {
                    event.stream_info.stream_payment_mode = 'paid';
                  } else if (element.ticket_type == 'free' && (element.sessions.includes(event.streamid) || element.sessions.includes(event.parent_streams_id))) {
                    event.stream_info.stream_payment_mode = 'free';
                  }
                });
              })
            }
            console.log(this.tickets)
            this.dataSourceRecVideo.data = this.sortedEventsData || [];
          } else {
            event.isMatched = false;
          }
        });
      } else {
        this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName)]);
      }
    }
  }
  leftScroll: boolean = false;
  scrollDatesLeft() {
    document.getElementById('dates-container').scrollLeft -= 40;
    this.rightScroll = true;
    if (document.getElementById('dates-container').scrollLeft == 0) {
      this.leftScroll = false
    }
  }
  rightScroll: boolean = true;
  scrollDatesRight() {
    document.getElementById('dates-container').scrollLeft += 40;
    this.leftScroll = true;
    if (Math.abs(document.getElementById('dates-container').scrollWidth) == (document.getElementById('dates-container').scrollLeft + Math.abs(document.getElementById('dates-container').offsetWidth))) {
      this.rightScroll = false;
    }
  }

  redirectTo(data) {
    let tag_category = this.tag_category == 'recorded-video' ? 'vod' : this.tag_category;
    let url = this.router.url + '?id=' + data.stream_info.id;
    if (this.userInfo.access_token) {
      this.checkAge((status) => {
        if (status == 'yes') {
          let noTickets = false;
          if (this.tickets.length > 0) {
            this.tickets.forEach(element => {
              if (element.sessions && (element.sessions.includes(data.streamid) || (element.sessions.includes(data.parent_streams_id))) && element.is_vod) {
                this.storageService.setItem('vodUrl', url);
                this.router.navigate([this.commonSubscribeService.getChannelBasePath(data.channel_name) + `/event/${data.slug}/place-order`]);
                noTickets = true;
              }
            });
            if (!noTickets) {
              this.toastr.info('No tickets found');
              return;
            }
          } else {
            if (this.priceDetails.message)
              this.toastr.info(this.priceDetails.message);
            else {
              this.toastr.info('No tickets found');
            }
          }
        } else {
          this.toastr.info("This " + tag_category + " is intended for persons of " + parseInt(this.agedata) + " years or older");
        }
      });
    } else {
      this.requireLogin(data);
    }
  }

  likeAudioVideo(subEvent, i) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const isLike = subEvent['stream_info'].is_liked == 0 ? "Liked" : "Disliked";
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Album ${albumId} ${isLike} - ${userId}`)
    const u_payload = {
      actionType: "network",
      metaData: {
        title: `Album ${albumId} ${isLike}`,
        albumId: albumId,
        albumName: this.streamInfo?.stream_video_title || null,
        videoId: subEvent?.streamid || null,
        videoTitle: subEvent?.stream_info?.stream_video_title || null,
        likeStatus: isLike,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo.organization_id || null,

      clickAction: `Album ${isLike}`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);

    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "event_id": subEvent['parent_streams_id'],
        "stream_id": subEvent['stream_info']['id'],
        "organization_id": subEvent['organization_id'],
        "userLike": (subEvent['stream_info'].is_liked == 0) ? 1 : 0         // 1 to like and 0 to unlike
      }
    }
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.LIKE_UNLIKE_AUDIO_VIDEO, data).then(response => {
      if (response.data.statusCode === '200') {
        if (subEvent['stream_info'].is_liked == 1) {
          this.subEvents[i]['stream_info'].is_liked = 0;
          this.subEvents[i]['stream_info'].user_likes = this.subEvents[i]['stream_info'].user_likes - 1;
        }
        else if (subEvent['stream_info'].is_liked == 0) {
          this.subEvents[i]['stream_info'].is_liked = 1;
          this.subEvents[i]['stream_info'].user_likes = this.subEvents[i]['stream_info'].user_likes + 1;
        }
      }
    }).catch(error => {
      console.log(error)
    });
  }

  shareVideo(subEvent) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Album ${albumId} share clicked - ${userId}`);

    const data = {
      actionType: "network",
      metaData: {
        title: `Album ${albumId} share clicked`,
        albumId: albumId,
        albumName: this.streamInfo?.stream_video_title || null,
        videoId: subEvent?.streamid || null,
        videoTitle: subEvent?.metadata?.stream_video_title || null,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo.organization_id || null,

      clickAction: 'album-share'
    }
    this.commonSubscribeService.sendTriggeredEvent(data);

    if (subEvent['shareSubEvent'] == false) {
      this.subEvents.forEach((element, index) => {
        if (subEvent['metadata'].id == element['metadata'].id) {
          this.subEvents[index]['shareSubEvent'] = true;
        } else {
          this.subEvents[index]['shareSubEvent'] = false;
        }
      });
    } else {
      this.subEvents.forEach((element, index) => {
        this.subEvents[index]['shareSubEvent'] = false;
      });
    }
  }

  closeSocialSharePopup(e) {
    if (e == true) {
      this.subEvents.forEach((element, index) => {
        this.subEvents[index]['shareSubEvent'] = false;
      });
    }
  }

  @HostListener('document:click', ['$event'])
  clickout() {
    this.subEvents.forEach((element, index) => {
      this.subEvents[index]['shareSubEvent'] = false;
    });
  }

  openTips(tipScreenMode?) {
    if (this.userInfo.access_token) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
      (window as any).umami?.track(`Album ${albumId} tips clicked ${userId}`);
      const data = {
        actionType: "network",
        metaData: {
          title: `Album ${albumId} tips clicked`,
          albumId: albumId,
          albumName: this.streamInfo?.stream_video_title || null,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.streamInfo.organization_id || null,

        clickAction: 'album-tips'
      }
      this.commonSubscribeService.sendTriggeredEvent(data);

      this.getCurrencytype = this.getCurrency ? this.getCurrency : this.currentLocation && this.currentLocation.currency && this.currentLocation.currency.code;
      let code = this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '';
      let currentCode = code.includes('\"') ? JSON.parse(code) : code;
      let localCurrency = this.getCurrency && this.getCurrency.includes('\"') ? JSON.parse(this.getCurrency) : this.getCurrency
      let channel_name = this.router.url.split("/")[1];
      this.ngOnDestroy();
      const dialogRef = this.dialog.open(TipsFeedbackPopupComponent, {
        data: {
          slug: this.activatedRoute.snapshot.params.slug_name.includes('?') ? this.activatedRoute.snapshot.params.slug_name.split('?')[0] : this.activatedRoute.snapshot.params.slug_name,
          id: typeof (this.userInfo.id) == 'string' ? this.userInfo.id : JSON.stringify(this.userInfo.id),
          channel_name: channel_name,
          currency: localCurrency ? localCurrency : currentCode,
          timezone: this.timezoneVal,
          tipsOrPolls: tipScreenMode ? tipScreenMode : this.tipsOrPolls,
          selectedVideoId: tipScreenMode ? this.selectedVideo.id : null,
          settingsData: this.settingsData
        },
        width: '550px',
        height: '560px',
        panelClass: 'app-tips-polls',
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result == true) {
          if (!this.selectedVideo.id) {
            this.ngOnInit();
          }
        }
      });
    } else {
      this.requireLogin();
    }
  }

  openPolls(tipScreenMode?: any) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Album ${albumId} polls clicked ${userId}`);

    const data = {
      actionType: "network",
      metaData: {
        title: `Album ${albumId} polls clicked`,
        albumId: albumId,
        albumName: this.streamInfo?.stream_video_title || null,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo.organization_id || null,

      clickAction: 'album'
    }
    this.commonSubscribeService.sendTriggeredEvent(data);

    if (this.userInfo.access_token) {
      this.getCurrencytype = this.getCurrency ? this.getCurrency : this.currentLocation && this.currentLocation.currency && this.currentLocation.currency.code;
      let code = this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '';
      let currentCode = code.includes('\"') ? JSON.parse(code) : code;
      let localCurrency = this.getCurrency && this.getCurrency.includes('\"') ? JSON.parse(this.getCurrency) : this.getCurrency;
      let channel_name = this.router.url.split("/")[1];
      this.ngOnDestroy();
      const dialogRef = this.dialog.open(TipsFeedbackPopupComponent, {
        data: {
          slug: this.activatedRoute.snapshot.params.slug_name.includes('?') ? this.activatedRoute.snapshot.params.slug_name.split('?')[0] : this.activatedRoute.snapshot.params.slug_name,
          id: typeof (this.userInfo.id) == 'string' ? this.userInfo.id : JSON.stringify(this.userInfo.id),
          channel_name: channel_name,
          currency: localCurrency ? localCurrency : currentCode,
          timezone: this.timezoneVal,
          tipsOrPolls: tipScreenMode ? tipScreenMode : 'Poll',
          // selectedVideoId:tipScreenMode?this.selectedVideo.id:null,
          selectedVideoId: tipScreenMode ? this.subEvents[0].streamid : null,
          settingsData: this.settingsData
        },
        width: '550px',
        height: '560px',
        panelClass: 'app-tips-polls',
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result == true) {
          if (!this.selectedVideo.id) {
            this.ngOnInit();
          }
        }
      });
    } else {
      this.requireLogin();
    }
  }

  startTimer() {
    this.displayTime = setInterval(() => {
      if (this.totalSeconds > 0) {
        this.days = Math.floor(this.totalSeconds / 86400);
        this.hours = Math.floor((this.totalSeconds - (this.days * 24 * 60 * 60)) / 3600);
        this.minutes = Math.floor((this.totalSeconds - ((this.days * 24 * 60 * 60) + this.hours * 60 * 60)) / 60);
        this.seconds = (this.totalSeconds - ((this.days * 24 * 60 * 60) + (this.hours * 60 * 60) + (this.minutes * 60)));
        this.totalSeconds = this.totalSeconds - 1;
      } else {
        this.showCountDownTimer = false;
      }
    }, 1000)
  }

  getUserInfo(callback) {
    let id = this.commonSubscribeService.getParam("user_id");
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        // "Authorization": `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        "user_id": id,
      }
    }
    // this.loader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER_BY_ID, data).then(response => {
      // this.loader.stop();
      if (response.data.user) {
        response.data.user.access_token = response.data.user.session_token;
        this.userInfo = this.commonSubscribeService.userInfo = response.data.user;
        this.commonSubscribeService.sendUserInfo(this.userInfo);
      }
      callback();
    }).catch(error => {
      // this.loader.stop();
    });
  }

  ngOnDestroy() {
    if (this.subscribePayInfoSubscr) {
      this.subscribePayInfoSubscr.unsubscribe();
    }
    if (this.performerInfoSubscr) {
      this.performerInfoSubscr.unsubscribe();
    }
    if (this.settingsDataSubscription)
      this.settingsDataSubscription.unsubscribe();
    if (this.userInfoSubscription) {
      this.userInfoSubscription.unsubscribe();
    }
    if (this.mediaPlayerDataSubscription) {
      this.mediaPlayerDataSubscription.unsubscribe();
    }
    if (this.currencyInfoSubscription) {
      this.currencyInfoSubscription.unsubscribe();
    }
    if (this.routerevents) {
      this.routerevents.unsubscribe();
    }
    this.appService.videoEnded.next(null);
    this.displayTime = null;
  }
  ngAfterViewChecked() {
    if (this.tag_category == 'recorded-video') {
      if ((Math.abs(document.getElementById('dates-container').scrollWidth) <= (document.getElementById('dates-container').scrollLeft + Math.abs(document.getElementById('dates-container').offsetWidth))) && ((Math.abs(document.getElementById('dates-container').scrollWidth) == Math.abs(document.getElementById('dates-container').offsetWidth)))) {
        this.rightScroll = false;
      }
      else if ((Math.abs(document.getElementById('dates-container').scrollWidth) == (document.getElementById('dates-container').scrollLeft + Math.abs(document.getElementById('dates-container').offsetWidth)))) {
        this.rightScroll = false;
      }
      else {
        this.rightScroll = true;
      }
    }

  }


}

@Component({
  selector: 'app-ios-modal',
  templateUrl: './ios-modal.html',
  styleUrls: ['./album-list.component.scss']
})
export class IOSModalDialog {

  copyLink: any;
  type: any = '';
  userInfo: any;
  settingsData: any;

  constructor(
    public dialogRef: MatDialogRef<IOSModalDialog>,
    private storageService: StorageService,
    private loader: NgxUiLoaderService,
    private commonSubscribeService: CommanSubscribeService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService,
    private dialog: MatDialog) {
    this.copyLink = data.url;
    this.type = data.type;
    this.userInfo = data.userInfo;
    this.settingsData = data.settingsData;
  }


  copyToClipboard(type) {
    const el = document.createElement('textarea');
    if (type == 'text-box') {
      el.value = this.copyLink;
    } else {
      el.value = this.copyLink;
    }
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    this.toastr.success("Copied..!")
  }

  openIn() {
    window.open(this.copyLink);
  }

  reload() {
    if (Object.keys(this.userInfo)?.length == 0) {
      this.storageService.setItem('skipIcRedirection', this.copyLink);
      const dialogRef = this.dialog.open(ConsumerSignInComponent, {
        maxWidth: "400px",
        panelClass: Object.keys(this.settingsData).length > 0 && this.settingsData.form_bg_color ? "app-consumer-signin" : "app-consumer-sign-in",
        disableClose: true,
        data: {}
      });
      dialogRef.afterClosed().subscribe(result => {
        //console.log(result);
        if (result == "success") {
          this.userInfo = this.commonSubscribeService.userInfo;
          this.dialogRef.close();
          this.storageService.deleteItem('skipIcRedirection');
          window.location.reload();
        }
      });
    } else {
      this.dialogRef.close();
      window.location.reload();
    }
    // let data = {
    //     headers: {
    //       "Content-Type": "application/json",
    //       "x-api-key": environment.AWS_Cognito.X_Api_Key,
    //       "Authorization": `Bearer ${this.userInfo.access_token}`,
    //     },
    //     response: true,
    //     body: {
    //       "user_id": this.userInfo.id
    //     }
    //   }
    //   this.loader.start();
    //   AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER_BY_ID, data).then(response => {
    //     this.loader.stop();
    //     if (response.data.user) {
    //       response.data.user.access_token = response.data.user.session_token;
    //       let access_token = { 'access_token': response.data.user.access_token }
    //       this.storageService.setItem("user_Info", access_token);
    //       this.userInfo = this.commonSubscribeService.userInfo = response.data.user;
    //       this.commonSubscribeService.sendUserInfo(this.userInfo);
    //       this.dialogRef.close();
    //       window.location.reload();
    //     }
    //   }).catch(error => {
    //     this.loader.stop();
    //     this.toastr.error('Unable to get user details');
    //   });
  }

  closeModal() {
    this.dialogRef.close();
  }


}
